import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type GlobalCurrencyWithId = {
  idGlobalCurrency: number;
};

// Базовый тип для операций с валютой и глобальной валютой
type CurrencyGlobalCurrencyPair = GlobalCurrencyWithId & {
  idCurrency: number;
};

// Типы для WebSocket сообщений компонента globalCurrencies
type GlobalCurrenciesListMessage = WebSocketMessageWithFields<'global-pair-list' | 'global-pair-root' | 'global-pair-exchange' | 'global-pair-indicator' | 'global-pair-calc' | 'global-pair-data' | 'global-pair-graph' | 'global-currency-list' | 'main' | 'pairs' | 'pairs-quantfury' | 'pair' | 'calc-info', {
  globalCurrencies: unknown[];
}>;
type GlobalCurrencyAddMessage = WebSocketMessageWithFields<'global-currency-add' | 'global-currency-add-success', CurrencyGlobalCurrencyPair>;
type GlobalCurrencyDeleteMessage = WebSocketMessageWithFields<'global-currency-delete' | 'global-currency-delete-success', GlobalCurrencyWithId>;
type GlobalCurrencyLockMessage = WebSocketMessageWithFields<'global-currency-lock' | 'global-currency-lock-success', GlobalCurrencyWithId>;
type GlobalCurrencyUnlockMessage = WebSocketMessageWithFields<'global-currency-unlock' | 'global-currency-unlock-success', GlobalCurrencyWithId>;
type GlobalCurrencyCurrencyAddMessage = WebSocketMessageWithFields<'global-currency-currency-add' | 'global-currency-currency-add-success', CurrencyGlobalCurrencyPair>;
type GlobalCurrencyCurrencyDeleteMessage = WebSocketMessageWithFields<'global-currency-currency-delete' | 'global-currency-currency-delete-success', CurrencyGlobalCurrencyPair>;

// Объединенный тип для всех сообщений
type GlobalCurrenciesWebSocketMessage = 
  | GlobalCurrenciesListMessage 
  | GlobalCurrencyAddMessage 
  | GlobalCurrencyDeleteMessage 
  | GlobalCurrencyLockMessage 
  | GlobalCurrencyUnlockMessage 
  | GlobalCurrencyCurrencyAddMessage 
  | GlobalCurrencyCurrencyDeleteMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataGlobalCurrencies',
},
  __name: 'globalCurrencies',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID глобальной валюты
const handleWebSocketMessage = (data: GlobalCurrenciesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'global-pair-list':
    case 'global-pair-root':
    case 'global-pair-exchange':
    case 'global-pair-indicator':
    case 'global-pair-calc':
    case 'global-pair-data':
    case 'global-pair-graph':
    case 'global-currency-list':
    case 'main':
    case 'pairs':
    case 'pairs-quantfury':
    case 'pair':
    case 'calc-info':
      store.dispatch('globalCurrencies/wsSetGlobalCurrencies', {
        globalCurrencies: data.globalCurrencies,
      });
      break;

    case 'global-currency-add':
    case 'global-currency-add-success':
      store.dispatch('globalCurrencies/wsGlobalCurrencyCreate', {
        idCurrency: data.idCurrency,
        idGlobalCurrency: data.idGlobalCurrency,
        locked: false,
      });
      break;

    case 'global-currency-delete':
    case 'global-currency-delete-success':
      store.dispatch('globalCurrencies/wsGlobalCurrencyDelete', {
        idGlobalCurrency: data.idGlobalCurrency,
      });
      break;

    case 'global-currency-lock':
    case 'global-currency-lock-success':
      store.dispatch('globalCurrencies/wsGlobalCurrencyLock', {
        idGlobalCurrency: data.idGlobalCurrency,
      });
      break;

    case 'global-currency-unlock':
    case 'global-currency-unlock-success':
      store.dispatch('globalCurrencies/wsGlobalCurrencyUnlock', {
        idGlobalCurrency: data.idGlobalCurrency,
      });
      break;

    case 'global-currency-currency-add':
    case 'global-currency-currency-add-success':
      store.dispatch('globalCurrencies/wsGlobalCurrencyCurrencyAdd', {
        idCurrency: data.idCurrency,
        idGlobalCurrency: data.idGlobalCurrency,
      });
      break;

    case 'global-currency-currency-delete':
    case 'global-currency-currency-delete-success':
      store.dispatch('globalCurrencies/wsGlobalCurrencyCurrencyDelete', {
        idCurrency: data.idCurrency,
        idGlobalCurrency: data.idGlobalCurrency,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})